import * as React from 'react';
/**
 * next.js 13 = 'next/image' => 'next/legacy/image'
 */
import Image, { ImageProps } from 'next/legacy/image';
import { log } from 'lib/log';
// import { baseUrl } from 'lib/base-url';
import { updateImagePaths } from 'lib/updateImagePaths';

const ImageContainer = (
    props: ImageProps & {
        fill?: boolean;
    }
) => {
    const customSrc = typeof props.src === 'string' ? updateImagePaths(props.src) : props.src;
    const layout = props.layout || 'fill';

    log(`customSrc output ==> ${customSrc}`);

    const { fill, ...imageprops } = props;

    return (
        <Image
            priority={props.priority}
            layout={props.fill === true ? 'fill' : props.layout}
            {...imageprops}
            width={layout !== 'fill' ? props.width : undefined}
            height={layout !== 'fill' ? props.height : undefined}
        />
    );
};

export type { ImageProps };

export default ImageContainer;
